import {
  ADD_ASSET_SELECTION, REMOVE_ASSET_SELECTION, INVALIDATE_ASSETS_SELECTION,
  ADD_COLLECTION_SELECTION, INVALIDATE_COLLECTION_SELECTION,
  UPDATE_RECIPIENT_NAMES,
  UPDATE_ATTACH_CONTENT,
  INVALIDATE_ATTACH_CONTENT,
  POPULATE_MEETING_DETAILS,
  POPULATE_DEAL_DETAILS,
  INVALIDATE_DEAL_DETAILS,
  PF_CHROME_WEBAPP_INVALIDATE_MEETING_DETAILS
} from 'constants/actionTypes';

const initialState = {
  assets: [],
  collection: null,
  multiSelectAsset: false,
  recipientNames: [],
  meetingDetails: {},
  dealDetails: {}
};

function selectionReducer(state = initialState, action) {
  switch (action.type) {
    case ADD_ASSET_SELECTION:
      var asset = action.payload;
      var assets = [asset, ...state.assets];

      assets = assets.reduce((x, y) => {
        var index = x.findIndex((e) => {
          return e === y;
        });

        if (index < 0) {
          return [...x, y];
        } else {
          x[index] = y;
          return x;
        }
      }, []);

      return {
        ...state,
        assets: assets,
        collection: null
      }

    case REMOVE_ASSET_SELECTION:
      var assets = state.assets || [];
      assets = assets.filter(item => {
        return item.id != action.payload.id;
      });

      return {
        ...state,
        assets: assets
      }
    case INVALIDATE_ASSETS_SELECTION:
      return {
        ...state,
        assets: []
      }

    case ADD_COLLECTION_SELECTION:
      var collection = action.payload;

      return {
        ...state,
        assets: [],
        collection: collection
      };

    case INVALIDATE_COLLECTION_SELECTION:
      return {
        ...state,
        collection: null
      };

    case UPDATE_RECIPIENT_NAMES:
      return{
        ...state,
        recipientNames: action.payload
      }
    
    case UPDATE_ATTACH_CONTENT:

      return{
        ...state,
        context: action.payload.context,
        selectedItems: action.payload.items,
        selectedItemsContent: action.payload.html
      }

    case INVALIDATE_ATTACH_CONTENT:
      return{
        ...state,
        selectedItems: [],
        selectedItemsContent: ""
      }

    case POPULATE_MEETING_DETAILS:

      return {
        ...state,
        meetingDetails: action.payload
      }

    case POPULATE_DEAL_DETAILS: 

    return {
      ...state,
      dealDetails: action.payload
    }

    case INVALIDATE_DEAL_DETAILS:
      return {
        ...state,
        dealDetails: {}
      }

    case PF_CHROME_WEBAPP_INVALIDATE_MEETING_DETAILS:
      return {
        ...state,
        meetingDetails: {}
      }

    default:
      return state;
  }
}

export { selectionReducer };


